import { onMounted } from 'vue'
import { fontFamilies } from "../ui/styles/text-styles-const";

export function useFontsLoadComplete(action: () => void) {
  useLoadComplete(fontFamilies, action);
}

export function useLoadComplete(_fonts: string[], action: () => void) {
  onMounted(() => {
    action();
  });
}
